import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../vqutils/vq-alert/vq-alert.component';
import { ApiService } from '../services/api.service';
import { ModalService } from '../vqutils/vq-modal/vq-modal.component';

@Component({
  selector: 'app-space-step-3',
  templateUrl: './space-step-3.component.html',
  styles: []
})
export class SpaceStep3Component implements OnInit {

  steps = [];
  step:any = {
    value: '',
    order: '',
  };
  errors:any = [];
  spaceId;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _as:AlertService,
    private _api: ApiService,
    private _ms: ModalService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        if(params['id']){
          this.spaceId = params['id'];
          this._api.keysteps
          .list({space: this.spaceId})
          .subscribe(
            (data) => {
              this.steps = data.results;
            },
            (errors) => {
            })
        }
      })
  }

  updateField(id, field, event){
    this._api.keysteps
    .partialUpdate(id, {[field] : event})
    .subscribe(
      (data) => {
        console.log(this.steps);
        this._as.success('L\'étape clé a été mise à jour');
      },
      (errors) => {
        this._as.danger('Des erreurs empêchent la mise à jour de l\'étape clé');
      })
  }

  addRow() {
    this.isLoading = true;
    this._api.keysteps
    .create({...this.step, space : this.spaceId})
    .subscribe(
      (data) => {
        this._as.success('L\'étape clé a été ajoutée');
        this.steps.push({...data});
        this.step = {
          value: '',
          order: '',
        };
        this.isLoading = false;
      },
      (errors) => {
        this.errors = errors;
        this._as.danger('Des erreurs empêchent la création de l\'étape clé');
        this.isLoading = false;
      })
  }

  private _deleteRow(row) {
    this._api.keysteps
    .destroy(row.id)
    .subscribe(
      (data) => {
        this._as.success('L\'étape clé a été supprimée');
        this.steps = this.steps.filter(o => o != row);
      },
      (errors) => {
        this._as.danger('Des erreurs empêchent la suppression de l\'étape clé');
      })
  }

  deleteRow(row){
    this._ms.delete({
      confirm: () => this._deleteRow(row)
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/space-step-3/space-step-3.component.ts